import { BaseWorkout, BodyParts, Equipment, EQUIPMENT_OTHER, FunxtionFitnessCategory, FunxtionFitnessType, MssWorkout, MssWorkoutType, MssWorkoutTypeNames, WorkoutBodyPartFilter, WorkoutDurationFilter, WorkoutEquipmentFilter, WorkoutFilterType, WorkoutFitnessCategoryFilter, WorkoutFitnessTypeFilter, WorkoutIntensities, WorkoutIntensityFilter, WorkoutTrainerFilter, WorkoutTypeFilter, WorkoutTypes } from '@/types/workouts'
import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules'
import store from '../index'
import workoutService from '@/services/workout.service'
import { workoutsModule } from './workouts.module'
import { allWorkoutsModule } from './all-workouts.module'
import { hasOwnProp } from '@/utils/object.utils'
import { DurationFilterLong, DurationFilterMedium, DurationFilterShort } from '@/types/state/general-filter'
import { DurationFilter } from '@/types/virtual-classes'

@Module
class AllWorkoutsOverviewModule extends VuexModule {
  
  private _filteredWorkouts: BaseWorkout[] = []

  readonly pageSize = 20

  currentPage = 1

  get lazyRenderingSliceSize() { return this.pageSize * this.currentPage }

  get filteredWorkouts() { return this._filteredWorkouts.slice(0, this.lazyRenderingSliceSize) }

  @Mutation
  private setFilteredWorkouts(workouts: BaseWorkout[]) {
    this._filteredWorkouts = workouts
  }

  @Mutation
  changePage(page: number) {
    this.currentPage = page
  }

  @Action
  applyFilters(arg: {
    workouts: BaseWorkout[];
    workoutFitnessCategories: FunxtionFitnessCategory[];
    workoutEquipments: Equipment[];
    workoutFitnessTypes: FunxtionFitnessType[];
    durationFilters: DurationFilter[];
    fitnessCategoryFilters: string[];
    fitnessTypeFilters: string[];
    typeFilters: string[];
    equipmentFilters: string[];
    intensityFilters: string[];
    trainerFilters: string[];
    searchPhraze: string;
    bodyPartFilters: string[];
  }) {

    this.changePage(1)

    let filteredWorkouts = arg.workouts
    if (arg.searchPhraze) {
      filteredWorkouts = workoutService.filterWorkoutsByName(filteredWorkouts, arg.searchPhraze)
    }
    if (arg.durationFilters.length) {
      filteredWorkouts = workoutService.filterWorkoutsByDuration(filteredWorkouts, arg.durationFilters)
    }
    if (arg.typeFilters.length) {
      filteredWorkouts = workoutService.filterWorkoutsByType(filteredWorkouts, arg.typeFilters)
    }
    if (arg.fitnessCategoryFilters.length) {
      filteredWorkouts = workoutService.filterWorkoutsByFitnessCategory(filteredWorkouts, arg.fitnessCategoryFilters,
        arg.workoutFitnessCategories)
    }
    if (arg.fitnessTypeFilters.length) {
      filteredWorkouts = workoutService.filterWorkoutsByFitnessType(filteredWorkouts, arg.fitnessTypeFilters, arg.workoutFitnessTypes)
    }
    if (arg.equipmentFilters.length) {
      filteredWorkouts = workoutService.filterWorkoutsByEquipment(filteredWorkouts, arg.equipmentFilters, arg.workoutEquipments)
    }
    if (arg.trainerFilters.length) {
      filteredWorkouts = workoutService.filterWorkoutsByTrainer(filteredWorkouts, arg.trainerFilters)
    }
    if (arg.intensityFilters.length) {
      filteredWorkouts = workoutService.filterWorkoutsByIntensity(filteredWorkouts, arg.intensityFilters)
    }
    if (arg.bodyPartFilters.length) {
      filteredWorkouts = workoutService.filterWorkoutsByBodyParts(filteredWorkouts, arg.bodyPartFilters)
    }
    this.setFilteredWorkouts(filteredWorkouts)
  }

  @Action
  initialize(workots: BaseWorkout[]) {
    this.setFilteredWorkouts(workots)
  }

  @Action
  nextPage() {
    if (this._filteredWorkouts.length > this.lazyRenderingSliceSize) {
      this.changePage(this.currentPage + 1)
    }
  }

  @Action
  reset() {
    this.setFilteredWorkouts(allWorkoutsModule.workouts)
  }
}

export const allWorkoutsOverviewModule = new AllWorkoutsOverviewModule({ store, name: 'allWorkoutsOverview' })